import { useMutation } from "@tanstack/react-query";

import { savePostModuleFeedbackApiCall } from "./utils.api";

export const useSavePostModuleFeedback = () =>
  useMutation({
    mutationFn: (body) => savePostModuleFeedbackApiCall(body),
  });
